if (!window.customAnimatedDividerLoaded) {
  window.customAnimatedDividerLoaded = true;

  const SELECTOR = '[data-cad]';
  const OFFSCREEN_CLASS = 'cad--offscreen';

  class CustomAnimatedDivider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-cad-track]');
      this.observer = null;
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      this._onMotionChange = this._onMotionChange.bind(this);
      this._onVisibilityChange = this._onVisibilityChange.bind(this);

      this.motionQuery.addEventListener('change', this._onMotionChange);
      document.addEventListener('visibilitychange', this._onVisibilityChange);

      this._setupIntersectionObserver();
    }

    _setupIntersectionObserver() {
      if (!('IntersectionObserver' in window) || !this.track) return;

      // Expand root margin so animation pre-starts just before entering viewport
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.el.classList.toggle(OFFSCREEN_CLASS, !entry.isIntersecting);
        },
        { rootMargin: '100px 0px' }
      );

      this.observer.observe(this.el);
    }

    _onMotionChange(e) {
      // Browser / OS motion preference changed at runtime — mirror to data attribute
      if (e.matches) {
        // User now prefers reduced motion: stop animation
        this.el.dataset.animate = 'false';
      } else {
        // Restore original setting stored at init time
        if (this.el.dataset.originalAnimate === 'true') {
          this.el.dataset.animate = 'true';
        }
      }
    }

    _onVisibilityChange() {
      if (!this.track) return;
      // Pause when tab is hidden to save resources
      this.track.style.animationPlayState = document.hidden ? 'paused' : '';
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.motionQuery.removeEventListener('change', this._onMotionChange);
      document.removeEventListener('visibilitychange', this._onVisibilityChange);
      this.el.classList.remove(OFFSCREEN_CLASS);
    }
  }

  const instances = new WeakMap();

  function getEls(root) {
    if (root instanceof Element && root.matches(SELECTOR)) return [root];
    return Array.from(root.querySelectorAll(SELECTOR));
  }

  function initSection(root) {
    getEls(root).forEach((el) => {
      if (instances.has(el)) return;
      // Snapshot original animate value before reduced-motion override can change it
      el.dataset.originalAnimate = el.dataset.animate;
      instances.set(el, new CustomAnimatedDivider(el));
    });
  }

  function destroySection(root) {
    getEls(root).forEach((el) => {
      const instance = instances.get(el);
      if (!instance) return;
      instance.destroy();
      instances.delete(el);
    });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSection(document), { once: true });
  } else {
    initSection(document);
  }

  // ── Shopify section lifecycle ─────────────────────────────────────────────

  document.addEventListener('shopify:section:load',   (e) => initSection(e.target));
  document.addEventListener('shopify:section:unload', (e) => destroySection(e.target));
}
